(function metadataControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataFindController', [
            '$scope', '$state', '$translate', 'errorsExtend', 'metadataService', 'authExtend',
            function metadataController($scope, $state, $translate, errors, metadataService, authExtend) {
                $scope.find = {
                    systemName: '_tipoDoc',
                    label: '',
                    organizationUnitId: authExtend.getOrganizationId(),
                    organizationUnitName: authExtend.getOrganizationName(),
                    showNoData: false
                };

                $scope.items = [];

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.find.showNoData = false;

                    return metadataService.get($scope.find).then(function getOk(result) {
                        $scope.items = result;
                        if ($scope.items.length === 0) {
                            $scope.find.showNoData = true;
                        }
                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.modify = function (metadata) {
                    $state.go('metadata-modify', { id: metadata.id });
                };

                $scope.view = function (metadata) {
                    $state.go('metadata-detail', { id: metadata.id });
                };

                $scope.add = function () {
                    $state.go('metadata-add');
                };

                $scope.load = function () {
                    $scope.findAction();
                }

                $scope.load();
            }
        ]);
})();